import { render, staticRenderFns } from "./shipped.vue?vue&type=template&id=17a147af&scoped=true"
import script from "./shipped.vue?vue&type=script&lang=js"
export * from "./shipped.vue?vue&type=script&lang=js"
import style0 from "./shipped.vue?vue&type=style&index=0&id=17a147af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a147af",
  null
  
)

export default component.exports